import { client } from ".";

async function getOverview() {
	const { data } = await client.get<OverviewResponse>(`/ai-usage/overview`);
	return data;
}

async function getClientsUsage(page: number = 1) {
	const { data } = await client.get<{ data: AiClientUsage[] } & Meta>(
		`/ai-usage/clients-usage`,
		{ params: { page } }
	);
	return data;
}

async function getAnalytics() {
	const { data } = await client.get<AnalyticsResponse>(`/ai-usage/analytics`);
	return data;
}

async function getClientLogs(clientId: number, page: number = 1) {
	const { data } = await client.get<{ data: AiUsageLog[] } & Meta>(
		`/ai-usage/clients/${clientId}/logs`,
		{ params: { page } }
	);
	return data;
}

export const aiUsageApi = {
	getOverview,
	getClientsUsage,
	getAnalytics,
	getClientLogs,
};
